import { PRIMARY_COLOR } from "../assets/style/colors";

export const MaskIcon = ({
  src,
  width = 20,
  height = 20,
  onClick,
  color = PRIMARY_COLOR,
  style = {},
}) => (
  <div
    style={{
      width,
      height,
      backgroundColor: color,
      WebkitMask: `url(${src}) center / contain no-repeat`,
      mask: `url(${src}) center / contain no-repeat`,
      display: "inline-block",
      flexShrink: 0,
      ...style,
    }}
    onClick={onClick}
  />
);